export default __webpack_public_path__ + "static/media/turtlelogo1.a87ed2f5.png";